var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/menu/nav_logo.svg")}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('common.title')))])]),_c('div',{staticClass:"right"},[_c('Lang')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }